/* eslint-disable import/extensions */
import * as actions from './action';
import * as getters from './getters';
import mutations from './mutations';

export default {
  state() {
    return {
      shieldsByDeviceId: [],
      devicesByShieldId: [],
      devicesByUserId: [],
      shieldsByUserId: [],
    };
  },
  mutations,
  actions,
  getters,
};
